import React from "react";
import { Button } from "@material-ui/core";
import { CircularProgress } from "@material-ui/core";

const LoadingButton = (props) => {
  const { children, classes, loading, startIcon, ...other } = props;
  if (loading) {
    return (
      <Button {...other} disabled>
        <CircularProgress size="12px" style={{marginRight: 5}}/> {children}
      </Button>
    );
  } else {
    return (
      <Button startIcon={startIcon} {...other}>
        {children}
      </Button>
    );
  }
};

export default LoadingButton;
